
import Main from '@/layout/main.vue'

const routes = [{
    path: '/',
    name: 'index',
    meta: { title: 'ภาพรวมระบบ' },
    redirect: '/index',
    component: Main,
    children: [{
        path: '/index',
        name: 'index',
        meta: {
            hidden: true,
            title: 'ภาพรวมระบบ',
            parentPath: '/',
            permission: ['view']
        },
        component: () => import('@/views/index/home.vue'),
    },
    ],
}]

export default routes